import axios from "axios";

export const searchCep = async (cep) => {
	try {
		const { data } = await axios.get(`https://viacep.com.br/ws/${cep}/json/`);

		if (data.erro) {
			throw new Error("Não foi possível encontrar o endereço correspondente a este CEP.");
		}

		return data;
	} catch (error) {
		const errorMessage = error.response
			? `Erro ao buscar CEP: ${error.response.status} - ${error.response.statusText}`
			: error.message || "Erro desconhecido ao buscar o CEP.";

		throw new Error(errorMessage);
	}
};

// if (cep.length !== 9) {
// 	return { erro: "Digite um cep válido. " };
// }
// return { erro: "Não foi possível encontrar o endereço correspondente a este cep." };
